var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "settings",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.333,
    height: 26.333,
    viewBox: "0 0 26.333 26.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_43",
    "data-name": "Ellipse 43",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(10 10)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2384",
    "data-name": "Path 2384",
    d: "M21.351,16.485a1.825,1.825,0,0,0,.365,2.013l.066.066a2.213,2.213,0,1,1-3.13,3.13l-.066-.066a1.84,1.84,0,0,0-3.119,1.305v.188a2.212,2.212,0,0,1-4.424,0v-.1a1.825,1.825,0,0,0-1.195-1.67,1.825,1.825,0,0,0-2.013.365l-.066.066a2.213,2.213,0,1,1-3.13-3.13l.066-.066A1.84,1.84,0,0,0,3.4,15.467H3.212a2.212,2.212,0,1,1,0-4.424h.1a1.825,1.825,0,0,0,1.67-1.195,1.825,1.825,0,0,0-.365-2.013L4.55,7.769a2.213,2.213,0,1,1,3.13-3.13l.066.066A1.825,1.825,0,0,0,9.76,5.07h.088A1.825,1.825,0,0,0,10.954,3.4V3.212a2.212,2.212,0,1,1,4.424,0v.1A1.84,1.84,0,0,0,18.5,4.617l.066-.066a2.213,2.213,0,1,1,3.13,3.13l-.066.066a1.825,1.825,0,0,0-.365,2.013v.088a1.825,1.825,0,0,0,1.67,1.106h.188a2.212,2.212,0,0,1,0,4.424h-.1A1.825,1.825,0,0,0,21.351,16.485Z",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/settings-icon.81238ce0b8ace4843409a655665cdaf9.svg";
export { ForwardRef as ReactComponent };